import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
export function snakeCaseToCamelCase(str) {
  if (str && typeof str === 'string') {
    return str.split('_').reduce(function (acc, part, index) {
      if (index === 0) {
        return "".concat(part[0].toLowerCase()).concat(part.substring(1));
      }
      return "".concat(acc).concat(part[0].toUpperCase()).concat(part.substring(1));
    }, '');
  }
  return str;
}